import { useDispatch, useSelector } from 'react-redux';
import { logout, setAuth } from '../redux/reducers/utils/authReducer';
import { Dropdown, Avatar, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Text, Title } from '../core/styles';
import { Link } from 'react-router-dom';

const HeaderProfileDropdownComponent = () => {
  const { userProfile } = useSelector((store) => store.auth);
  const dispatch = useDispatch();
  
  const handleLogout = async () => {
    try {
      const requestData = {
        requestTimestamp: Date.now(),
      };

      // Показываем индикатор загрузки
      const hideLoading = message.loading('Выход из системы...', 0);

      try {
        // Выполняем logout
        await dispatch(logout(requestData)).unwrap();
        
        // Очищаем localStorage на всякий случай
        dispatch(setAuth(false));
        localStorage.removeItem('token');
        localStorage.removeItem('session');

        hideLoading();
      } catch (error) {
        console.error('Ошибка при logout:', error);
        
        // Очищаем localStorage на всякий случай
        dispatch(setAuth(false));
        localStorage.removeItem('token');
        localStorage.removeItem('session');
        
        hideLoading();
        message.warning('Произошла ошибка, но вы вышли из системы');
      }
    } catch (error) {
      console.error('Критическая ошибка при logout:', error);
      message.error('Критическая ошибка при выходе');
    }
  };

  const items = [
    {
      key: '1',
      label: userProfile ? 
        <div onClick={(e) => e.stopPropagation()}>
          <Text size='12px'>ID: {userProfile.userId}</Text>
          <Title level={5}>{userProfile.phone}</Title>
          <Text>{userProfile.name}</Text>
          
        </div>
      : 'Loading...',
      disabled: true,
    },
    {
      key: '2',
      label: (
        <Link to={'/settings/profile'}>Профиль</Link>
      ),
    },
    {
      key: '3',
      label: (
        <Link onClick={handleLogout}>Выйти</Link>
      ),
    },
  ];

  return (
    <StyledDropdown menu={{ items }} trigger={['click']}>
      <Avatar icon={<UserOutlined />} onClick={(e) => e.preventDefault()}/>
    </StyledDropdown>
  );
};

export default HeaderProfileDropdownComponent;

const StyledDropdown = styled(Dropdown)`
  margin-left: auto;
`
